import React, {Component} from 'react';
import {Card, CardBody, CardHeader} from 'reactstrap';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import {getData} from '../../../api/doLogin.js';
import {formatDateTime} from "../../../util/datehelpers";
import BannerItem from "./BannerItem";
import {EventClient} from "../../../util/eventClient";
import {deleteData} from "../../../api/doLogin";

const brandPrimary = '#20a8d8';
const brandSuccess = '#4dbd74';
const brandInfo = '#63c2de';
const brandWarning = '#f8cb00';
const brandDanger = '#f86c6b';

class BannerList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      dataLoaded: false,
      showHistory: false,
      chosenBanner: null
      // chosenBanner: {}
    };

    this.table = this.state.data || [];
    this.options = {
      sortIndicator: true,
      hideSizePerPage: true,
      paginationSize: 5,
      hidePageListOnlyOnePage: true,
      clearSearch: true,
      alwaysShowAllBtns: false,
      withFirstAndLast: false
    }

  }

  componentDidMount() {
    this.updateData();
  }

  // componentDidUpdate(prevProps, prevState) {
  //   if (prevProps.match.params.type !== this.props.match.params.type) {
  //     this.updateData();
  //   }
  // }

  updateData() {
    var self = this;
    getData("admin/banners/list", {})
      .then((data) => {
        // console.log(data);
        if (data.status === "Success") {
          self.setState({data: data.data.banners, dataLoaded: true});
        }
      })
      .catch(error => {
        EventClient.emit("TOAST_ERROR", error.message);
        console.error(error);
      });
  }

  deleteBanner(id) {
    var self = this;
    deleteData(`admin/banners/${id}`, {})
      .then((data) => {
        // console.log(data);
        if (data.status === "Success") {
          self.updateData();
        }
      })
      .catch(error => {
        EventClient.emit("TOAST_ERROR", error.message);
        console.error(error);
      });
  }

  buttonFormatter(cell, row, context) {
    return (
      <div>
        <button onClick={() => this.setState({chosenBanner: row})}>Edit</button>
        <button onClick={() => confirm(`Are you sure you want to remove banner?`) && this.deleteBanner(row.id)}>
          Remove
        </button>
        {/*{(row.status === 'error' || row.status === 'complete') &&*/}
        {/*<button onClick={() => context.props.history.push("/applications/submit_" + row.uuid)}>View Results</button>*/}
        {/*}*/}
        {/*{(row.status === 'processing') &&*/}
        {/*<button onClick={() => context.props.history.push("/applications/submit_" + row.uuid)}>See Progress</button>*/}
        {/*}*/}
      </div>
    )
  }

  status(cell, row, context) {
    // console.log(new Date(row.startDate), Date.now())
    if (new Date(row.endDate) < new Date()) {
      return "Disabled";
    } else if (new Date(row.startDate) < new Date()) {
      return "Active";
    } else {
      return "Queued";
    }
  }

  statusCell(cell, row, context) {
    return `${this.status(cell, row, context)}/${row.files} image(s)`
  }

  filterEntry(entry) {
    let resp = this.status("", entry, this);
    if (this.state.showHistory) {
      return resp === "Disabled";
    } else {
      return resp === "Active" || resp === "Queued";
    }
  }

  render() {
    return (
      <div className="animated fadeIn">
        {this.state.dataLoaded && (
          <Card>
            <CardHeader>
              <i className="icon-menu"></i>Splash Banner Administration

              <div className="card-actions">
                <button onClick={() => this.updateData()}>
                  <small className="text-muted">Refresh</small>
                </button>
                <button onClick={() => this.setState({showHistory: !this.state.showHistory})}>
                  <small className="text-muted">{`${this.state.showHistory ? "Active" : "Archived"}`}</small>
                </button>
                <button onClick={() => this.setState({chosenBanner: {}})}>
                  <small className="text-muted">Add</small>
                </button>
              </div>

            </CardHeader>
            <CardBody>
              <div style={{textAlign: 'right'}}>Click the Add button above to add new Banner Campaign.</div>
              <BootstrapTable data={(this.state.data || []).filter((entry) => this.filterEntry(entry))}
                              version="4" striped hover pagination options={this.options}>
                <TableHeaderColumn isKey={true} dataField="id" hidden>Id</TableHeaderColumn>
                <TableHeaderColumn dataField="display" dataSort>Name</TableHeaderColumn>
                <TableHeaderColumn dataField="status"
                                   dataFormat={(cell, row) => this.statusCell(cell, row, this)}>Status</TableHeaderColumn>
                <TableHeaderColumn dataField="startDate" dataSort
                                   dataFormat={(cell, row) => formatDateTime(new Date(cell))}>Start</TableHeaderColumn>
                <TableHeaderColumn dataField="endDate" dataSort
                                   dataFormat={(cell, row) => formatDateTime(new Date(cell))}>End</TableHeaderColumn>
                <TableHeaderColumn dataField="button"
                                   dataFormat={(cell, row) => this.buttonFormatter(cell, row, this)}>Actions</TableHeaderColumn>
              </BootstrapTable>
            </CardBody>
          </Card>
        )}
        {!!this.state.chosenBanner && (
          <BannerItem banner={this.state.chosenBanner}
                      onClose={() => this.setState({chosenBanner: null})}
                      categories={this.state.categories}
                      onUpdate={() => {
                        this.updateData();
                      }}
                      onAdd={(data) => {
                        this.setState({chosenBanner: {...data}})
                      }}
          />
        )}
      </div>
    )
  }
}

export default BannerList;



// WEBPACK FOOTER //
// ./src/containers/Admin/SplashBanner/BannerList.js